var userFullName = function userFullName(user) {
  return (user && user.first_name || '') + ' ' + (user && user.last_name || '');
};
export default userFullName;